import React from "react";
import GoogleMapReact from "google-map-react";
import LocationPin from "../location/location.component";

import "./google-map.styles.scss";

const location = {
  address: "Oswego, IL, USA",
  lat: 41.7169649,
  lng: -88.361904,
  zoomLevel: 14,
};

const GoogleMapComp = () => (
  <div className="map">
    <div className="google-map">
      { <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyAVc6xd2t4R_zrDRMw3qfsGmtKYWfpvLQM" }}  
        defaultCenter={location}
        defaultZoom={location.zoomLevel}
      >
        <LocationPin
          
          lat={location.lat}
          lng={location.lng}
          text={location.address}
        />
      </GoogleMapReact > 
      }
    </div>
  </div>
);

export default GoogleMapComp;
